import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { CommentIndicatorComponent } from './comment-indicator.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		MatTooltipModule,
		TranslateModule
	],
	declarations: [
		CommentIndicatorComponent
	],
	exports: [
		CommentIndicatorComponent
	],
	providers: [
		TranslatePipe
	]
})
export class CommentIndicatorModule {}
